import React, { useState, useEffect } from "react";
import styles from "../styles/AdBlock.module.scss";

//Used on pages where we rely on Analytics(GTM) like on /purchase

export const AdblockUI = (props) => {
  return (
    <div className={styles.adBlockPage}>
      <div className={styles.adBlockContainer}>
        <img
          className={styles.logo}
          src={"https://frontend-assets.buildbox.com/logo.png"}
          alt="bb_logo"
        ></img>
        <p className={styles.message}>
          Please turn off your ad blocker and refresh this page
        </p>
      </div>
    </div>
  );
};
const AdblockDetector = ({ children }) => {
  const [usingAdblock, setUsingAdblock] = useState(false);

  let fakeAdBanner;

  useEffect(() => {
    if (fakeAdBanner) {
      const hasAdBlock = fakeAdBanner.offsetHeight === 0;
      setUsingAdblock(hasAdBlock);
      sessionStorage.setItem("adBlockEnabled", hasAdBlock);
    }
  }, [fakeAdBanner]);

  //Borrowed this from here: https://stackoverflow.com/a/60710181/8805046
  return (
    <>
      <div>
        <div
          ref={(r) => (fakeAdBanner = r)}
          style={{
            height: "1px",
            width: "1px",
            visibility: "hidden",
            pointerEvents: "none",
            backgroundColor: "#1f1f1f",
          }}
          className="adsbox ad-banner"
        />
      </div>
      {usingAdblock ? <AdblockUI /> : children}
    </>
  );
};

export default AdblockDetector;
